import ModalContainer from 'components/Common/Modal/ModalContainer';

export default ModalContainer;
